import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { useSingleEmailComposer, useUserSession } from '../../../../../models/hooks/appStateHooks';
import { white } from '../../../../styles/colors';
import { DetailsFlyout } from '../../../DetailsFlyout';
import { styleSheet as flyoutStyleSheet } from '../../../DetailsFlyout/styles';
import { EntityChip } from '../../../chips/EntityChip';
import { EmailIcon } from '../../../svgs/icons/EmailIcon';
import { styleSheet } from './styles';

export const MatterDetailsFlyout = ({
	isOpen,
	setIsOpen,
	matter,
}: {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	matter: Api.ILegalMatter;
}) => {
	const userSession = useUserSession();
	const singleEmailComposer = useSingleEmailComposer();

	const formatDate = (dateString?: string) => {
		if (!dateString) return '-';
		return moment(dateString).format('MM/DD/YYYY');
	};

	const sendEmail = () => {
		if (matter.contact) {
			const contactVm = new Api.ContactViewModel(userSession, matter.contact);
			singleEmailComposer.showForRecipients([contactVm]);
		}
	};

	return (
		<DetailsFlyout isOpen={isOpen} setIsOpen={setIsOpen} title='Matter Details'>
			<div className={css(styleSheet.container)}>
				<section className={css(styleSheet.section)}>
					<h4 className={css(flyoutStyleSheet.subTitle)}>{matter.matterName}</h4>
					{matter.matterNumber ? <small>#{matter.matterNumber}</small> : null}
				</section>

				{matter.contact ? (
					<section className={css(styleSheet.section)}>
						<span className={css(styleSheet.label)}>Contact</span>
						<EntityChip
							entity={new Api.ContactViewModel(userSession, matter.contact)}
							readOnly={true}
							sizeConstraint='compact'
						/>
					</section>
				) : null}

				{matter.contact?.primaryEmail?.value ? (
					<section className={css(styleSheet.quickActions)}>
						<a className={css(styleSheet.quickActionButton)} onClick={sendEmail}>
							<EmailIcon fillColor={white} width={16} height={14} />
						</a>
					</section>
				) : null}

				<div className={css(flyoutStyleSheet.separator)} />

				<section className={css(styleSheet.detailsSection)}>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Stage</span>
						<span className={css(styleSheet.value)}>{matter.stage || '-'}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Status</span>
						<span className={css(styleSheet.value)}>{matter.status || '-'}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Practice Area</span>
						<span className={css(styleSheet.value)}>{matter.practiceArea || '-'}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Open Date</span>
						<span className={css(styleSheet.value)}>{formatDate(matter.openDate)}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Close Date</span>
						<span className={css(styleSheet.value)}>{formatDate(matter.closeDate)}</span>
					</div>
				</section>
			</div>
		</DetailsFlyout>
	);
};
